var _rect, _g, _rect2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialFacebookRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#social_facebook_round_svg__clip0_23701_2494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 20c0-6.075-4.925-11-11-11S9 13.925 9 20c0 5.159 3.552 9.487 8.343 10.676v-7.314h-2.268V20h2.268v-1.448c0-3.744 1.694-5.48 5.37-5.48.697 0 1.9.137 2.391.273v3.047c-.26-.027-.71-.04-1.27-.04-1.804 0-2.5.683-2.5 2.46V20h3.592l-.617 3.362h-2.976v7.558C26.78 30.261 31 25.623 31 20z",
    fill: "#0866FF"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 39.5,
    height: 39.5,
    rx: 19.75,
    stroke: "#000",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "social_facebook_round_svg__clip0_23701_2494"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(9 9)",
    d: "M0 0h22v22H0z"
  })))));
}

export default SvgSocialFacebookRound;